const links = [
  { title: "Home", to: "/" },
  { title: "Shop", to: "/shop" },
  { title: "Posts", to: "/posts" },
  { title: "Artists", to: "/artists" },
  { title: "Releases", to: "/releases" },
  { title: "Services", to: "/services" },
];

export const extraLinks = [
  {
    to: "https://discord.gg/w3GJKkh7J3",
    target: "_blank",
    icon: "iconoir:discord",
  },
  { to: "/about", target: "", icon: "iconoir:info-empty" },
  { to: "/cart", target: "", icon: "iconoir:cart" },
];

export default links;
